export const getTrackTutorialStepsForDesktopScreen = (): any => {
  return [
    {
      content: (
        <h5>
          Let&#39;s walk-through what you can do with your uploaded tracks.
        </h5>
      ),
      locale: { skip: <strong>SKIP</strong> },
      target: "body",
      placement: "center",
    },
    {
      content: (
        <h5>
          Share your track with the OmMuse Community by setting your track to
          public. By default all tracks are private.
        </h5>
      ),
      target: "#track-privacy-switch",
    },
    {
      content: (
        <h5>
          Add a new version of your track. You can manage all your track
          versions on the Track page by clicking anywhere on this row to open
          it.
        </h5>
      ),
      target: "#step-13",
    },
    {
      content: (
        <h5>
          Add additional files such as project (i.e. Ableton or Garage Band),
          stems, and artwork, as you make your new track. You&#39;ll also be
          able to manage these files from the File&#39;s tab and within the
          Track page.
        </h5>
      ),
      target: "#step-14",
    },
    {
      content: <h5>Download the current track version.</h5>,
      target: "#step-15",
    },
    {
      content: <h5>Edit track details such as artist or album.</h5>,
      target: "#step-16",
    },
    {
      content: (
        <h5>
          Master your track using Dolby.io AI Mastering. You can preview from 15
          different presets before creating your final master.
        </h5>
      ),
      target: "#step-17",
    },
    {
      content: (
        <h5>
          Mint an NFT for your track and create a Smart Contract to share
          distribution of royalties with your collaborators.
        </h5>
      ),
      target: "#step-18",
    },
    {
      content: (
        <h5>
          Add existing OmMuse users or invite new ones! They will automatically
          be added to the track once they register.
        </h5>
      ),
      target: "#step-19",
    },
    {
      content: (
        <h5>
          Have some comments on a track? Use the Track message channel to store
          comments and share your notes with your collaborators. Every track
          gets it&#39;s own channel.
        </h5>
      ),
      target: "#step-20",
    },
    {
      content: (
        <h5>
          Click anywhere on the row to open up the Track page where you can
          manage additional versions, files, and collaborators.
        </h5>
      ),
      target: "#step-21",
    },
  ];
};

export const getTrackTutorialStepsForSmallScreen = (): any => {
  return [
    {
      content: (
        <h5>
          Let&#39;s walk-through what you can do with your uploaded tracks.
        </h5>
      ),
      locale: { skip: <strong>SKIP</strong> },
      target: "body",
      placement: "center",
    },
    {
      content: (
        <h5>
          {" "}
          Share your track with the OmMuse Community by setting your track to
          public. By default all tracks are private.
        </h5>
      ),
      target: "#step-12",
    },
    {
      content: (
        <h5>
          Add new track versions, add files (such as session, lyrics, or stems),
          download, edit track details, or master your track with Dolby.io AI
          Mastering with the track menu.
        </h5>
      ),
      target: "#small-screen-track-menu",
    },
    {
      content: (
        <h5>
          Add existing OmMuse users or invite new ones! They will automatically
          be added to the track once they register.
        </h5>
      ),
      target: "#step-19",
    },
    {
      content: (
        <h5>
          Have some comments on a track? Use the Track message channel to store
          comments and share your notes with your collaborators. Every track
          gets it&#39;s own channel.
        </h5>
      ),
      target: "#step-20",
    },
    {
      content: (
        <h5>
          {" "}
          Click anywhere on the row to open up the Track page where you can
          manage additional versions, files, and collaborators.
        </h5>
      ),
      target: "#step-21",
    },
  ];
};
